import { Component, OnInit, Input } from '@angular/core';
import { GenericResponse } from 'src/app/data/repository/generic-response';
import * as moment from 'jalali-moment';
import { UserApiService } from 'src/app/data/repository/user-repository/user-api.service';

@Component({
  selector: 'app-edit-birthdate',
  templateUrl: './edit-birthdate.component.html',
  styleUrls: ['./edit-birthdate.component.scss'],
})
export class EditBirthdateComponent implements OnInit {
  @Input() birthdate: string;

  showYearPrefix = false;
  date: string[];
  thirdInputText = '';
  secondInputText = '';
  hasError = false;

  constructor(private userApiService: UserApiService) {}

  ngOnInit() {
    this.date = ['', '', ''];
    const date = new Date(parseInt(this.birthdate));
    const d = moment
      .from(
        date.getFullYear().toString() +
          '-' +
          (date.getMonth() + 1).toString() +
          '-' +
          date.getDate().toString(),
        'YYYY-MM-DD'
      )
      .locale('fa');
    this.date[0] = d.format('DD');
    this.date[1] = d.format('MM');
    this.date[2] = d.format('YY');
    this.showYearPrefix = true;
  }

  save(): Promise<GenericResponse> {
    let response: GenericResponse;
    if (!this.hasErrors()) {
      const y = '13' + this.date[2];
      const d = moment.from(
        y + '/' + this.date[1] + '/' + this.date[0],
        'fa',
        'YYYY/MM/DD'
      );
      const day = d.format('DD');
      const month = d.format('MM');
      const year = d.format('YYYY');
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      this.birthdate = date.getTime().toString();
      // console.log('saved', this.birthdate)
      return this.userApiService.editUser(
        null,
        null,
        parseInt(this.birthdate),
        null,
        null
      );
    } else {
      response = new GenericResponse(false);
      return Promise.resolve(response);
    }
  }

  checkActivatingButton(index: number) {
    this.hasError = false;
    if (index !== 2 && this.date[index].length === 2) {
      document.getElementById('input-' + index).blur();
      document.getElementById('input-' + (index + 1)).focus();
    } else {
      if (this.date[2] && this.date[2].length !== 0) {
        this.thirdInputText = this.date[2];
      }
    }
    if (index === 1 && this.date[1].length !== 0) {
      this.secondInputText = this.date[1];
    }
  }

  keytab(event, index: number) {
    this.hasError = false;
    if (
      index !== 0 &&
      event.key === 'Backspace' &&
      (!this.date[index] || this.date[index] === '')
    ) {
      if (index === 2 && this.date[index] !== this.thirdInputText) {
        this.thirdInputText = this.date[index];
        return;
      }
      if (index === 1 && this.date[index] !== this.secondInputText) {
        this.secondInputText = this.date[index];
        return;
      }
      document.getElementById('input-' + index).blur();
      document.getElementById('input-' + (index - 1)).focus();
      this.date[index - 1] = '';
    }
  }

  hasErrors() {
    const d = '13' + this.date[2] + '/' + this.date[1] + '/' + this.date[0];
    const todayJalali = moment.from(d, 'fa', 'YYYY/MM/DD');
    if (!todayJalali.isValid()) {
      this.hasError = true;
      return true;
    }
    return false;
  }

  activateYearPrefix() {
    if (!this.date[2] || this.date[2] === '') {
      this.showYearPrefix = true;
    }
  }

  disableYearPrefix() {
    if (!this.date[2] || this.date[2] === '') {
      this.showYearPrefix = false;
    }
  }
}
